export default __webpack_public_path__ + "static/media/open-sans-regular.17e98b9e.ttf";